// extracted by mini-css-extract-plugin
module.exports = {"bodyFreeze":"Modal-module__bodyFreeze___qdsF8"};